import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  navBarContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    padding: '20px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.10)',
    background: '#FFFFFF',
  },
  navBar: {
    display: 'flex',
    height: '24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  brandContainer: {
    height: '24px',
  },
  signOutContainer: {
    color: tokens.colorStrokeFocus2,
    fontSize: '14px',
    fontWeight: 500,
  },
});
